<template>
  <div style="padding: 10px;">
    <!-- 预付款申请单 -->
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>预付款申请单</b>
      </div>
      <div>
        <el-form ref="form" :model="form" label-width="100px">
          <el-row>
            <el-col :span="8">
              <el-form-item label="单据编号" prop="ccode">
                <el-input v-model="form.ccode" placeholder="单据编号" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item label="核算主体" prop="ctcbs">
                <el-input v-model="form.ctcbs" placeholder="核算主体" readonly />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="申请日期" prop="ddate">
                <el-input v-model="form.ddate" placeholder="申请日期" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报销人" prop="cstaffname">
                <el-input v-model="form.cstaffname" placeholder="报销人" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="付款币种" prop="ccurrency">
                <el-input v-model="form.ccurrency" placeholder="付款币种" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="预付申请金额" prop="iprepaidfees">
                <el-input v-model="form.iprepaidfees" placeholder="预付申请金额" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="付款方式" prop="cpaymentmethod">
                <el-input v-model="form.cpaymentmethod" placeholder="付款方式" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="部门" prop="cdepname">
                <el-input v-model="form.cdepname" placeholder="部门" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="申请说明" prop="cremarks">
                <el-input type="textarea" v-model="form.cremarks" placeholder="申请说明" :rows="3" maxlength="300"
                  show-word-limit readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="供应商" prop="cvenname">
                <el-input v-model="form.cvenname" placeholder="供应商" readonly />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="银行账号" prop="caccountnumber">
                <el-input v-model="form.caccountnumber" placeholder="银行账号" readonly />
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="账户持有人" prop="caccount">
                <el-input v-model="form.caccount" placeholder="账户持有人" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="银行行号" prop="cbankcode">
                <el-input v-model="form.cbankcode" placeholder="银行行号" readonly />
              </el-form-item>
            </el-col> -->
            <el-col :span="8">
              <el-form-item label="付款金额" prop="ipaymentmoney">
                <el-input v-model="form.ipaymentmoney" placeholder="付款金额" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单据类型" prop="cdocumenttype">
                <el-input v-model="form.cdocumenttype" placeholder="单据类型" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="资金计划" prop="cfundingplan">
                <el-input v-model="form.cfundingplan" placeholder="资金计划" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="业务类型" prop="cbusinesstype">
                <el-input v-model="form.cbusinesstype" placeholder="业务类型" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="费控单号" prop="cfccode">
                <el-input v-model="form.cfccode" placeholder="费控单号" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="提交费控日期" prop="dfcdate">
                <el-input v-model="form.dfcdate" placeholder="提交费控日期" readonly />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="审核结果" prop="cauditresult">
                <el-input v-model="form.cauditresult" placeholder="审核结果" readonly />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div id="out-table">
      <el-card class="box-card boxcard">
        <div>
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="订单明细" name="订单明细">
              <el-table border :data="dtDet" style="width: 100%;min-height: 200px;max-height: 350px;" height="350px">
                <el-table-column type="index" align="center" label="序号" width="50" />
                <el-table-column label="付款状态" align="center" prop="cpaymenttype" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="银行账号" align="center" prop="caccountnumber_det" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="账户持有人" align="center" prop="caccount_det" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="银行行号" align="center" prop="cbankcode_det" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="采购订单号" align="center" prop="cordcode" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="订单日期" align="center" prop="dorddata" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="订单金额" align="center" prop="iordmoney" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="预付款比例(%)" align="center" prop="iprepay" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="可申请预付款金额" align="center" prop="isqyfje" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="本次预付金额" align="center" prop="ibcyfje" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="明细备注" align="center" prop="cremarks_det" :show-overflow-tooltip="true"
                  min-width="120" />
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="附件信息" name="附件信息">
              <el-table border :data="dtFile" style="width: 100%;min-height: 200px;max-height: 350px;" height="350px">
                <el-table-column type="index" align="center" label="序号" width="50" />
                <el-table-column label="附件名称" align="center" prop="cfilename" :show-overflow-tooltip="true"
                  min-width="220" />
                <el-table-column label="附件路径" align="center" prop="cfilepath" :show-overflow-tooltip="true"
                  min-width="220" />
                <el-table-column label="上传人" align="center" prop="coper" :show-overflow-tooltip="true"
                  min-width="100" />
                <el-table-column label="上传时间" align="center" prop="dupload" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="操作" align="center" width="130" class-name="small-padding fixed-width"
                  fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" icon="el-icon-edit" @click="handCK(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="银行汇票" name="银行汇票">
              <el-table border :data="dtDraft" style="width: 100%;min-height: 200px;max-height: 350px;" height="350px">
                <el-table-column type="index" align="center" label="序号" width="50" />
                <el-table-column label="银行汇票" align="center" prop="cbankdraft" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="路径" align="center" prop="cdraftpath" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="接收日期" align="center" prop="dreceive" :show-overflow-tooltip="true"
                  min-width="120" />
                <el-table-column label="操作" align="center" width="130" class-name="small-padding fixed-width"
                  fixed="right">
                  <template slot-scope="scope">
                    <el-button size="mini" type="text" icon="el-icon-edit" @click="handYHHP(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { RemovePruchaseToDo, GetFileType } from "@/api/home";
  export default {
    data() {
      return {
        form: {
          ccode: '',
          ctcbs: '',
          ddate: '',
          cstaffname: '',
          ccurrency: '',
          iprepaidfees: '',
          cpaymentmethod: '',
          cdepname: '',
          cremarks: '',
          cvenname: '',
          caccountnumber: '',
          caccount: '',
          cbankcode: '',
          ipaymentmoney: '',
          cdocumenttype: '',
          cfundingplan: '',
          cbusinesstype: '',
          cfccode: '',
          dfcdate: '',
          cauditresult: '',
        },
        activeName: '订单明细',
        dtDet: [],
        dtDraft: [],
        dtFile: [],
        loading: true,
        keyid: '',
        SRMFC: '',
      };
    },
    created() {
      this.keyid = this.$route.query.keyid;
      this.SRMFC = this.$route.query.SRMFC;
      console.log(this.keyid, this.SRMFC, '434543')
      this.GetInquiryInfo();

    },

    methods: {
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      handCK(row) {
        console.log(row)
        window.open('https://srm.ryytngroup.com/' + row.cfilepath);
      },
      handYHHP(row) {
        console.log(row)
        window.open(row.cdraftpath);
      },
      // 获取信息
      GetInquiryInfo() {
        this.$axios({
          method: "post",
          url: "CommonModule/FC/GetAdvanceChargeInfo",
          headers: {
            'x-srm-signature': this.SRMFC
          },
          data: { keyid: this.keyid },
        }).then((res) => {
          console.log(res, "获取信息结果");
          if (res.data.Success) {
            this.form = res.data.Data.dtMain[0];
            this.dtFile = res.data.Data.dtFile
            this.dtDraft = res.data.Data.dtDraft
            this.dtDet = res.data.Data.dtDet
          } else {
            this.$message.error(res.data.Message);
          }
        });
      },
    },
    beforeDestroy() {
      this.informdata = {};
    },

  };
</script>
<style scoped>
  .el-form-item {
    margin-bottom: 10px;
    font-weight: 900;
  }

  .el-card__header .clearfix span {
    font-size: 12px;
  }

  .Projectdetails>>>.el-input__inner {
    border: 0;
    background: #f7f7f7;
  }

  .tb-edit .el-input,
  .tb-edit .el-select,
  .tb-edit .el-textarea {
    display: none;
  }

  .tb-edit .current-row .el-input,
  .tb-edit .current-row .el-select,
  .tb-edit .current-row .el-textarea {
    display: block;
  }

  .tb-edit .current-row .el-input+span,
  .tb-edit .current-row .el-select+span,
  .tb-edit .current-row .el-textarea+span {
    display: none;
  }

  .infodata {
    margin-bottom: 10px;
  }

  .infodata span {
    margin: 0 10px;
  }

  .Projectdetails /deep/ .el-input.is-disabled /deep/ .el-input__inner {
    border-color: transparent;
    background: transparent;
    color: #606266;
  }
</style>